import React from "react";
import tempJson from "../../../../json/fallbackglobalvariables.json";
import { Outlet, useLocation } from "react-router";
import styles from "../../../../styles/easyPaySettings.module.scss";

const EasyPayMain = () => {
  const labels = tempJson.acc;
  const loc = useLocation();
  const path = loc.pathname;

  return (
    <div  className={`${styles["bg-gray-100"]} ${styles["mb-40"]} ${styles["p-md-30"]} ${styles["mb-40"]} ${styles["tru-mma-main-wrapper"]}`} >
      {/* Top Section */}
      {path.includes("easypay-settings") && !path.includes("update-easypay-preferences") && !path.includes("update-easypay-success") && (
        <div className={styles.headerSection}>
          <div className={`${styles["gfw-3"]} p-0`}>
            <span className={`${styles["gfs-lg-30"]} ${styles["glh-1_2"]} ${styles["mb-10"]} ${styles["text-gray-med"]}`}
              dangerouslySetInnerHTML={{ __html: labels.epManageEasyPay }}
            />
          </div>
          <div className={`${styles["gfw-3"]} ${styles["mb-20"]}`}>
            <span
              className={`d-block ${styles["gfs-20"]}`}
              dangerouslySetInnerHTML={{
                __html: labels.epEditPaymentMethods,
              }}
            />
          </div>
          <div className={`col-12 ${styles["gfw-3"]} p-0 ${styles["mb-20"]}`}>
            <span
              className={`d-block ${styles["gfs-24"]}`}
              dangerouslySetInnerHTML={{
                __html: labels.epServCurrentlyEnrolled,
              }}
            />
          </div>
        </div>
      )}
      {path.includes("update-easypay-preferences") && (
        <div className={styles.headerSection}>
          <div className={`${styles["gfw-3"]} ${styles["titleBlock"]} p-0 d-block`}>
            <span className={`${styles["gfs-lg-30"]} ${styles["glh-1_2"]} ${styles["mb-10"]} ${styles["text-gray-med"]}`}
              dangerouslySetInnerHTML={{
                __html: labels.updateEasyPayPreferences,
              }}
            />
          </div>
          <div className={`${styles["gfw-3"]} ${styles["mb-20"]} d-block`}>
            <span
              className={`d-block ${styles["gfs-20"]}`}
              dangerouslySetInnerHTML={{
                __html: labels.descriptionEP,
              }}
            />
          </div>
        </div>
      )}

      <div className={styles.outletSection}>
        <Outlet />
      </div>
    </div>
  );
};

export default EasyPayMain;
